<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-coupon_expiring-description') }}
        </p>
        <div class="field">
            <label :class="{ label: true, 'label-danger': !isValid() }"
                >{{ t('automations-form-triggers_config-coupon_expiring-threshold_label') }}
            </label>
            <input
                type="tel"
                required
                v-model="threshold"
                class="form-control"
                v-mask="'##'"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let threshold =
            this.value.length > 0 && this.value[0].threshold
                ? parseInt(this.value[0].threshold)
                : 2;
        return {
            threshold: threshold,
        };
    },
    mounted() {
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid() {
            if (this.threshold) {
                return true;
            }
        },
        changed: function () {
            this.$emit("input", [
                {
                    threshold: this.threshold,
                },
            ]);
        },
    },
    watch: {
        threshold() {
            this.changed();
        },
        value() {
            let threshold =
                this.value.length > 0 && this.value[0].threshold
                    ? parseInt(this.value[0].threshold)
                    : 2;
            if (threshold !== this.threshold) {
                this.threshold = threshold;
            }
        },
    },
};
</script>
